<template>
    <div class="container py-5">

        <h1 class="konfirmasi-title">Detail Pelanggaran</h1>

        <DetailPelanggaran @data-loaded="handleDataLoaded" />

        <div class="modal fade" id="modalNotes" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content shadow-lg">

                    <div class="modal-header">
                        <h3 class="modal-title fw-bold">
                            Notes
                        </h3>
                    </div>

                    <div class="modal-body notes-body">

                        <p>
                            Titipan pembayaran denda maksimal sebesar
                            Rp500.000/pasal.- (lima ratus ribu rupiah)
                            dan berlaku kelipatan apabila pelanggar melakukan
                            lebih dari 1 (satu).
                        </p>

                        <p>
                            Perkara pelanggaran selanjutnya diajukan ke proses
                            persidangan di pengadilan.
                        </p>

                        <p>
                            Berdasarkan hasil putusan pengadilan, apabila terdapat
                            sisa dana titipan denda, maka pengembalian akan dilakukan
                            melalui rekening milik pelanggar yang bersangkutan.
                        </p>

                        <p>
                            Dalam hal pengembalian dana dilakukan ke rekening atas
                            nama pihak lain, maka proses pengembalian akan
                            dilaksanakan secara manual melalui teller bank sesuai
                            ketentuan yang berlaku.
                        </p>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary px-4" data-bs-dismiss="modal">
                            OK
                        </button>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import DetailPelanggaran from "./DetailPelanggaran.vue";
import { Modal } from "bootstrap";

export default {
    components: {
        DetailPelanggaran,
    },

    data() {
        return {
            currentStep: 0,

            noReferensi: "",
            tnkb: "",
        };
    },
    mounted() {

        const refNumber = this.$route.query.ref_number;
        const plates = this.$route.query.plates;

        if (refNumber && plates) {

            this.noReferensi = refNumber;
            this.tnkb = plates;

            this.currentStep = 2;
        }
    },

    methods: {
        handleDataLoaded() {
            const modal = new Modal(
                document.getElementById("modalNotes")
            );

            modal.show();
        }
    },
};

</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 80px;
}

.konfirmasi-title {
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  color: #2E3686;
  margin-bottom: 2rem;
}

.step-title {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background-color: #f5f6fa;
  border-radius: 10px;
  padding: 15px 25px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 2.5rem;
}

.step {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  margin: 5px;
}

.step-active {
  background-color: #2E3686;
  color: #fff;
  box-shadow: 0 2px 8px rgba(46, 54, 134, 0.4);
}

.step-inactive {
  background-color: #e4e6f1;
  color: #4a4a4a;
}

.form-section {
  animation: fadeIn 0.4s ease;
}

.modal-content {
  border-radius: 15px;
}

.modal-header {
  padding: 25px 35px;
}

.modal-title {
  font-size: 2.2rem;
  color: #1f2937;
}

.notes-body {
  padding: 35px;
  font-size: 1.5rem;
  line-height: 2.2rem;
  color: #333;
}

.notes-body p {
  margin-bottom: 25px;
}

.modal-footer {
  padding: 20px 35px;
}

.modal-footer .btn {
  min-width: 120px;
  font-size: 1.2rem;
  font-weight: 600;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .step-title {
    flex-direction: column;
    text-align: center;
  }

  .step {
    width: 100%;
  }
  
  .container {
    max-width: 100% !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
</style>